"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "user-form-container" };
const _hoisted_2 = { class: "user-details" };
const _hoisted_3 = {
    key: 0,
    class: "profile-photo-container"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "fake-avatar profile-photo"
};
const _hoisted_6 = { class: "form-padding" };
const _hoisted_7 = { class: "form-group user-new-form-group" };
const _hoisted_8 = { for: "employee-id" };
const _hoisted_9 = {
    key: 0,
    class: "text-gray"
};
const _hoisted_10 = { class: "col-12" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "form-padding" };
const _hoisted_13 = { for: "name" };
const _hoisted_14 = { class: "form-padding" };
const _hoisted_15 = { for: "input-furigana" };
const _hoisted_16 = { class: "form-padding" };
const _hoisted_17 = { for: "input-phone" };
const _hoisted_18 = ["readonly"];
const _hoisted_19 = { class: "form-padding" };
const _hoisted_20 = { for: "preferred-branch" };
const _hoisted_21 = ["data-tooltip"];
const _hoisted_22 = { value: "none" };
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "form-padding" };
const _hoisted_25 = { for: "locale" };
const _hoisted_26 = { value: "" };
const _hoisted_27 = { class: "form-padding user-form-footer" };
const _hoisted_28 = {
    key: 0,
    class: "user-details"
};
const _hoisted_29 = { class: "form-padding smartHR-token" };
const _hoisted_30 = { class: "oplus-form-text" };
const _hoisted_31 = ["data-tooltip"];
const _hoisted_32 = { class: "input-group flex-end" };
const _hoisted_33 = ["value"];
const _hoisted_34 = ["value"];
const _hoisted_35 = { class: "email-form-footer" };
const _hoisted_36 = { class: "user-details" };
const _hoisted_37 = { class: "form-padding" };
const _hoisted_38 = {
    class: "oplus-form-text",
    for: "change-email"
};
const _hoisted_39 = { class: "input-group edit-email-form" };
const _hoisted_40 = ["value"];
const _hoisted_41 = ["value"];
const _hoisted_42 = { class: "email-form-footer" };
const _hoisted_43 = { class: "user-details" };
const _hoisted_44 = { class: "form-padding" };
const _hoisted_45 = {
    class: "oplus-form-text",
    for: "password"
};
const _hoisted_46 = { class: "input-group edit-password-form" };
const _hoisted_47 = { class: "form-input text-ellipsis br-5" };
const _hoisted_48 = {
    key: 0,
    class: "oplus-gray-text",
    for: "password"
};
const _hoisted_49 = {
    key: 1,
    class: "oplus-gray-text",
    for: "password"
};
const _hoisted_50 = { class: "email-form-footer" };
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { key: 1 };
const vue_3 = require("vue");
const EditIcon_vue_1 = __importDefault(require("../icons/EditIcon.vue"));
const vue_i18n_1 = require("vue-i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'UserNewForm',
    props: {
        user: {},
        thisUser: {},
        enabledSmartHR: { type: Boolean, default: false },
        profilePhotoEnabled: { type: Boolean, default: false },
        hasSmartHRAttendenceToken: { type: Boolean, default: false },
        imageURL: {}
    },
    emits: ["open-password-modal", "open-email-modal", "open-smartHR-attendance-token-modal", "open-photo-modal"],
    setup(__props, { emit: __emit }) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const props = __props;
        const emit = __emit;
        const isLoading = (0, vue_3.ref)(false);
        const formData = (0, vue_3.reactive)({
            name: props.user.Name,
            furigana: props.user.Furigana,
            phone: props.user.Phone || props.thisUser.phone || '',
            SMSVerified: props.thisUser.phone ? 1 : 0,
            preferredBranch: props.thisUser.employsCompanies.find((b) => b.isPreferred)?.id || 'none',
            employeeID: props.user.ID,
            locale: props.user.Locale,
        });
        const loadingClass = (0, vue_3.computed)(() => isLoading.value ? 'loading' : '');
        const isReadonly = (0, vue_3.computed)(() => !!(props.thisUser.phone || props.user.SMSVerified));
        const hasMultipleIDs = (0, vue_3.computed)(() => Object.keys(props.thisUser.employeeIDMap).length > 1);
        const isEmailEmpty = (0, vue_3.computed)(() => props.user.Email === '-');
        function getCompanyNames(comIDList) {
            return comIDList.map(comID => props.thisUser.comMap[comID]?.Name || '').join(', ');
        }
        async function handleSubmit() {
            if (isLoading.value)
                return;
            if (!validate())
                return;
            isLoading.value = true;
            $.post(props.thisUser.url, formData)
                .done(() => {
                window.location.reload();
            })
                .fail((response) => {
                console.error(response);
                isLoading.value = false;
            });
        }
        function handleOpenPasswordModal() {
            emit('open-password-modal');
        }
        function handleOpenEmailModal() {
            emit('open-email-modal');
        }
        function openSmartHRAttendanceTokenModal() {
            emit('open-smartHR-attendance-token-modal');
        }
        function openPhotoModal() {
            emit('open-photo-modal');
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (__props.profilePhotoEnabled)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.title")), 1 /* TEXT */),
                            (__props.imageURL !== ``)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                    key: 0,
                                    src: __props.imageURL,
                                    class: "profile-photo"
                                }, null, 8 /* PROPS */, _hoisted_4))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)(__props.user.Name.slice(0, 2)), 1 /* TEXT */)),
                            (0, vue_2.createVNode)(EditIcon_vue_1.default, {
                                class: "edit",
                                onClick: openPhotoModal
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.thisUser.employeeIDMap, (comIDList, employeeID) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("label", _hoisted_8, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.employee_id')) + " ", 1 /* TEXT */),
                                    (hasMultipleIDs.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_9, " (" + (0, vue_2.toDisplayString)(getCompanyNames(comIDList)) + ") ", 1 /* TEXT */))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_2.createElementVNode)("input", {
                                        class: "form-input user-new-form-id br-5",
                                        name: "employeeID",
                                        value: employeeID,
                                        readonly: ""
                                    }, null, 8 /* PROPS */, _hoisted_11)
                                ])
                            ]));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    (0, vue_2.createElementVNode)("form", {
                        onSubmit: (0, vue_2.withModifiers)(handleSubmit, ["prevent"])
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createElementVNode)("label", _hoisted_13, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.name')) + " ", 1 /* TEXT */),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.name) = $event)),
                                    class: "form-input br-5",
                                    type: "text",
                                    name: "name",
                                    id: "input-name",
                                    placeholder: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelText, formData.name]
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("label", _hoisted_15, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.furigana')) + " ", 1 /* TEXT */),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.furigana) = $event)),
                                    class: "form-input br-5",
                                    type: "text",
                                    name: "furigana",
                                    id: "input-furigana",
                                    placeholder: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelText, formData.furigana]
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            (0, vue_2.createElementVNode)("label", _hoisted_17, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.phone')) + " ", 1 /* TEXT */),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.phone) = $event)),
                                    class: "form-input br-5",
                                    type: "tel",
                                    name: "phone",
                                    id: "input-phone",
                                    placeholder: "",
                                    "data-com.agilebits.onepassword.user-edited": "yes",
                                    readonly: isReadonly.value
                                }, null, 8 /* PROPS */, _hoisted_18), [
                                    [vue_2.vModelText, formData.phone]
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                            (0, vue_2.createElementVNode)("label", _hoisted_20, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.preferred_branch')) + " ", 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("i", {
                                    class: "preferred-help-icon zmdi zmdi-help zmdi-hc-1x tooltip",
                                    "data-tooltip": (0, vue_2.unref)(t)('user.preferred_branch_tooltip')
                                }, null, 8 /* PROPS */, _hoisted_21)
                            ]),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formData.preferredBranch) = $event)),
                                class: "form-select br-5",
                                name: "preferred-branch"
                            }, [
                                (0, vue_2.createElementVNode)("option", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.none')), 1 /* TEXT */),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.thisUser.employsCompanies, (branch) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                        key: branch.id,
                                        value: branch.id
                                    }, (0, vue_2.toDisplayString)(branch.name), 9 /* TEXT, PROPS */, _hoisted_23));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                                [vue_2.vModelSelect, formData.preferredBranch]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                            (0, vue_2.createElementVNode)("label", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.language')), 1 /* TEXT */),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formData.locale) = $event)),
                                class: "form-select br-5",
                                name: "locale"
                            }, [
                                (0, vue_2.createElementVNode)("option", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.default_language')), 1 /* TEXT */),
                                _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("option", { value: "ja-JP" }, "日本語", -1 /* CACHED */)),
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("option", { value: "en-US" }, "English (United States)", -1 /* CACHED */)),
                                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("option", { value: "zh-CN" }, "中文（简体）", -1 /* CACHED */)),
                                _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("option", { value: "zh-TW" }, "中文（繁體）", -1 /* CACHED */))
                            ], 512 /* NEED_PATCH */), [
                                [vue_2.vModelSelect, formData.locale]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-confirm-btn"])
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.update')), 3 /* TEXT, CLASS */)
                        ])
                    ], 32 /* NEED_HYDRATION */)
                ]),
                (0, vue_2.createCommentVNode)(" SmartHR Attendance Token "),
                (__props.enabledSmartHR)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                        (0, vue_2.createElementVNode)("div", _hoisted_29, [
                            (0, vue_2.createElementVNode)("label", _hoisted_30, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.smarthr_api_token')) + " ", 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("span", {
                                    "data-tooltip": (0, vue_2.unref)(t)('user.smarthr_api_token_tooltip'),
                                    class: "circle-question tooltip"
                                }, null, 8 /* PROPS */, _hoisted_31)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                (!__props.hasSmartHRAttendenceToken)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                        key: 0,
                                        class: "form-input text-ellipsis br-5 disabled-input",
                                        value: (0, vue_2.unref)(t)('user.api_token_not_set'),
                                        disabled: ""
                                    }, null, 8 /* PROPS */, _hoisted_33))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                        key: 1,
                                        class: "form-input text-ellipsis br-5 disabled-input",
                                        value: (0, vue_2.unref)(t)('user.api_token_set'),
                                        disabled: ""
                                    }, null, 8 /* PROPS */, _hoisted_34))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                (0, vue_2.createElementVNode)("button", {
                                    id: "email-modal-btn",
                                    class: "oplus-modal-btn oplus-confirm-btn font-sm ml-1 br-5",
                                    type: "button",
                                    onClick: openSmartHRAttendanceTokenModal
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('general.save')), 1 /* TEXT */)
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("div", _hoisted_36, [
                    (0, vue_2.createCommentVNode)(" Email Form "),
                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                        (0, vue_2.createElementVNode)("label", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.email')), 1 /* TEXT */),
                        (0, vue_2.createElementVNode)("div", _hoisted_39, [
                            (isEmailEmpty.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                    key: 0,
                                    class: "form-input text-ellipsis br-5",
                                    value: (0, vue_2.unref)(t)('user.no_login_email'),
                                    disabled: ""
                                }, null, 8 /* PROPS */, _hoisted_40))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                    key: 1,
                                    class: "form-input text-ellipsis br-5",
                                    value: __props.user.Email,
                                    disabled: ""
                                }, null, 8 /* PROPS */, _hoisted_41))
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_42, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "email-modal-btn",
                                class: "oplus-modal-btn oplus-confirm-btn email-form-btn",
                                type: "button",
                                onClick: handleOpenEmailModal
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.change_email')), 1 /* TEXT */)
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                    (0, vue_2.createCommentVNode)(" Password Form "),
                    (0, vue_2.createElementVNode)("div", _hoisted_44, [
                        (0, vue_2.createElementVNode)("label", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.password')), 1 /* TEXT */),
                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                            (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                (__props.thisUser.isUserHasPassword)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_48, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.password_already_set')), 1 /* TEXT */))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_49, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.password_not_set')), 1 /* TEXT */))
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_50, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "password-modal-btn",
                                class: "oplus-modal-btn oplus-confirm-btn email-form-btn",
                                type: "button",
                                onClick: handleOpenPasswordModal
                            }, [
                                (__props.thisUser.isUserHasPassword)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_51, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.change_password')), 1 /* TEXT */))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_52, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('user.create_password')), 1 /* TEXT */))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
